<template>
  <div>
    <div>
      <div>
        <b-card>
          <font
            size="5"
            color="green"
          >
            <span style="color:gray;"><center> Sayaç Ekleme Paneli</center></span>
          </font><hr>
          <div>
            <b-form-select
              id="head"
              v-model="selected8"
              :options="options8"
              class="mb-1"
            >
              <b-form-select-option
                :value1="null"
                disabled
              >
                Sayaç Eklenecek Enerji Türünüzü Belirtiniz!
              </b-form-select-option>
              <b-form-select-option value="yes">
                <b>Elektrik</b>
              </b-form-select-option>
              <b-form-select-option value="no">
                <center>Doğalgaz</center>
              </b-form-select-option>
              <b-form-select-option value="no">
                <b>Su</b>
              </b-form-select-option>
              <b-form-select-option value="no">
                <b>Güneş Enerji Kaynağı</b>
              </b-form-select-option>
            </b-form-select>
          </div>
          <hr>
          <div>
            <b-form-select
              id="head"
              v-model="selected8"
              :options="options8"
              class="mb-1"
            >
              <b-form-select-option
                :value1="null"
                disabled
              >
                Sektör Adını Seçiniz
              </b-form-select-option>

            </b-form-select>
          </div>

          <div>
            <b-card>
              <invoice-tablo class="table" /></b-card>
          </div>
          <!-- Button: Send Invoice -->

          <b-table
            responsive="sm"
            :items="items"
          />
          <b-form
            ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain"
          >

            <br>

            <!-- Row Loop -->
            <b-row
              v-for="(item, index) in items"
              :id="item.id"
              :key="item.id"
              ref="row"
              class="yann"
            >

              <!-- Item Name -->
              <b-col lg="4">

                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Sayaç Seri No"
                  />
                </b-form-group>
                <b-form-group

                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Sayaç Adı"
                  />
                </b-form-group>

                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Sayaç Markası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Sayaç Türü"
                  />
                </b-form-group>
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="Selected"
                    name="some-radios"
                    value="A"
                  >
                    AG Abonesi
                  </b-form-radio>
                  <b-form-radio
                    v-model="Selected"
                    name="some-radios"
                    value="B"
                  >
                    OG Abonesi
                  </b-form-radio>
                </div>
              </b-col>

              <!-- Cost -->

              <!-- Quantity -->
              <b-col md="4">

                <b-form-group
                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="date"
                    placeholder="Tarih"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder=" Sayaç Modeli"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Sayaç Konumu "
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Sayaç İmalat Yılı "
                  />
                </b-form-group>
                <div class="demo-inline-spacing">
                  <span>Trafo Kaybı Var mı?</span>
                  <b-form-radio
                    v-model="Selected"
                    name="some-radios"
                    value="A"
                  >
                    Evet
                  </b-form-radio>
                  <b-form-radio
                    v-model="Selected"
                    name="some-radios"
                    value="B"
                  >
                    Hayır
                  </b-form-radio>
                </div>
              </b-col>

              <!-- Profession -->

              <!-- Remove Button -->
              <b-col
                lg="3"
                md="2"
                class="mb-50"
              >
                <b-card>

                  <!-- Button: DOwnload -->

                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="success"
                    class="mb-75"
                    block
                    @click="alert1"
                  >
                    <feather-icon
                      icon="CornerUpRightIcon"
                      class="mr-25"
                    />
                    Kaydet
                  </b-button>

                  <!-- Button: Print -->
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="danger"
                    block
                    @click="removeItem(index)"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      class="mr-0"
                    />
                    Temizle
                  </b-button>

                </b-card>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>

          </b-form>
          <b-button
            id="bbtn"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="secondary"
            class="mb-75"
            @click="repeateAgain"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
            Yeni Sayaç Ekle
          </b-button>
        </b-card></div>
    </div>
  </div></template>

<script>
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BButton, BFormRadio, BFormSelect, BFormSelectOption, BCard,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'

import Ripple from 'vue-ripple-directive'
import InvoiceTablo from './InvoiceTablo.vue'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    InvoiceTablo,
    BFormRadio,
    BFormSelect,
    BFormSelectOption,
    BCard,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
      nextTodoId: 2,
    }
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },
    removeItem(index) {
      this.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    alert1() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('...... Seri Numaralı Sayaç Eklensin Mi?', {
          title: 'Sayaç Ekleme Onayı',
          size: 'bg',
          okVariant: 'success',
          okTitle: 'Onayla',
          cancelTitle: 'İptal',
          cancelVariant: 'danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          this.boxTwo = value
        })
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    setup() {
      const printInvoice = () => {
        window.print()
      }

      return {
        printInvoice,
      }
    },
    selected: null,
    options: [
      { value: null, text: 'Seçim Yapınız' },
      { value: 'a', text: 'Elektrik' },
      { value: 'b', text: 'Doğalgaz' },
      { value: 'c', text: 'Su' },
    ],
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>

<style>
#head{
  background-color: bisque;
}
.table{
  background-color: beige;
}

</style>
